import Tooltip from 'antd/es/tooltip';
import dayjs from 'dayjs';
import { EyeIcon } from 'shared/ui/icons';

const STATUS_STYLES = {
  SUBMITTED: 'bg-green-50 text-green-500',
  PROCESSING: 'bg-blue-50 text-blue-500',
  FAILED: 'bg-red-50 text-red-500',
};

const DEFAULT_STATUS_STYLE = 'bg-slate-50 text-slate-500';

export const StatusBadge = ({ status, t }) => {
  const style = STATUS_STYLES[status] || DEFAULT_STATUS_STYLE;
  const label =
    status === 'SUBMITTED'
      ? t('status_done')
      : t(`status_${(status || '').toLowerCase()}`);

  return <span className={`px-2 ${style} rounded-lg capitalize`}>{label}</span>;
};

export const getDisplayName = (item) => {
  const orgName = item?.organization_name;
  if (!orgName || orgName === 'Not specified in document') {
    return item?.country?.name || '-';
  }
  return orgName;
};

export const getTariffBookColumns = (t) => [
  {
    key: 'organization_name',
    label: t('hospital_name'),
    align: 'text-left',
    isSortable: true,
  },
  {
    key: 'starting_date',
    label: t('start_date'),
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'rules',
    label: t('rules'),
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'status',
    label: t('label_status'),
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'actions',
    label: '',
    align: 'text-right',
    classCell: 'sticky-cell flex justify-end ',
    classHead: 'sticky-cell-head w-14',
  },
];

const DiscountRuleCell = ({ rule }) => {
  if (!rule) return '-';
  return (
    <Tooltip placement="bottom" title={rule}>
      <div className="truncate max-w-[220px]">{rule}</div>
    </Tooltip>
  );
};

export const mapTariffBookRows = (data, t, navigate) =>
  data?.data?.map((item) => {
    const displayName = getDisplayName(item);

    return {
      starting_date: item?.starting_date
        ? dayjs(item.starting_date).format('DD MMM YYYY')
        : '-',
      organization_name: (
        <Tooltip placement="bottom" title={displayName}>
          <div className="w-auto">{displayName}</div>
        </Tooltip>
      ),
      rules: <DiscountRuleCell rule={item?.discount_rule} />,
      status: <StatusBadge status={item?.status} t={t} />,
      actions: (
        <button
          type="button"
          className="cursor-pointer"
          onClick={() => navigate(`/buku-tarif/detail/${item?.id}`)}
          aria-label={`${t('action_view_detail')} ${displayName}`}
        >
          <EyeIcon color="#6b7280" />
        </button>
      ),
    };
  }) ?? [];
